import { AbortError } from "./abort";
import { internalsField } from "../../common/errors";
import { RequestError } from "./request";
import { TimeoutError } from "./timeout";

Object.defineProperty(window, internalsField, { value: {} });
window[internalsField].errors = { AbortError, TimeoutError, RequestError };
